import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useDiscoverTheme } from '../../../common/emotion/theme';

export const InfoMessage = styled.div(() => {
  const {
    colors: { RegularFontWeight },
  } = useDiscoverTheme();

  return css`
    font-size: 14px;
    font-weight: ${RegularFontWeight};
  `;
});
